const AirFreight = () => {
  return (
    <div>
        
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center">
              <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                Air Freight
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                Empowered by its own aviation division, TCS offers a wide array of air freight services and transit times 
                including airport-to-airport, door-to-door, airport-to-doorstep, and doorstep-to-airport. Ideal for larger 
                shipments that may or may not require a pallet, you can also benefit from other services, e.g. pickup, 
                collection, delivery and customs clearance.
              </p>
              
          </div>
          <div className="flex-1 flex flex-col justify-center items-center lg:mt-[0rem] mt-[1rem]">
            <img src="/international-freight/Air-Freight-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>

      </div>

    </div>
  );
  };
  
export default AirFreight;
  